import { Injectable } from '@angular/core';
import { FormBase } from '@mapfre-design-library/src/public_api';
import { EmailPasswordFormService } from '../email-password-form/email-password-form.service';

@Injectable()
export class EditPasswordService {
  constructor(private passwordService: EmailPasswordFormService) {}

  getInputs(id: string) {
    const inputs: FormBase<any>[] = [
      this.passwordService.getPasswordInputs(
        id,
        '',
        'ENTER_YOUR_CURRENT_PASSWORD'
      ),
    ];
    return inputs;
  }
}
